export default function( {redirect}) {
    redirect('https://www.cosmo.ph/tag/cosmo-on-campus');
  }
  